import cs from 'classnames';

import { getCategoryName } from '../lib/helpers';

import IconCard from './IconCard';
import IconGroup from './IconGroup';

const CategorySection = ({ category, grouped, individual, onIconClick }) => {
  // Sort grouped icons by size - groups with ≤3 items first, then groups with >3 items
  const sortedGrouped = Object.entries(grouped).sort(([familyA, iconsA], [familyB, iconsB]) => {
    const aSize = iconsA.length;
    const bSize = iconsB.length;

    // If one has ≤3 items and the other has >3 items, prioritize the smaller one
    if (aSize <= 3 && bSize > 3) return -1;
    if (aSize > 3 && bSize <= 3) return 1;

    // If both are in the same category (both ≤3 or both >3), sort alphabetically
    return familyA.localeCompare(familyB);
  });

  return (
    <div className="mb-8">
      <h2 className="text-xxl mb-4 font-500 text-secondary-600">
        {getCategoryName(Number(category))}
      </h2>
      <div
        className={cs(
          'grid gap-4',
          category !== '0' ? 'grid-cols-5' : 'grid-cols-[repeat(auto-fill,minmax(190px,1fr))]'
        )}>
        {sortedGrouped.map(([family, icons]) => (
          <IconGroup
            key={`family-${family}`}
            family={family}
            icons={icons}
            category={category}
            onIconClick={onIconClick}
          />
        ))}
        {individual.map((icon) => (
          <IconCard key={`icon-${icon.name}`} onIconClick={onIconClick} {...icon} />
        ))}
      </div>
    </div>
  );
};

export default CategorySection;
